import { render, staticRenderFns } from "./B.vue?vue&type=template&id=8f181960&"
import script from "./B.vue?vue&type=script&lang=js&"
export * from "./B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports